import Modal from './Modal'
import ModalFooter from './Components/ModalFooter'
import { ModalWrapper } from './Styles'

export default Modal
export { ModalWrapper, ModalFooter }
